// Export the Component Definition for use in Contentful Studio
export {TextCollectionContentfulComponentDefinition} from './TextCollectionContentfulDefinition';
export {default} from './TextCollection';
export type {TextCollectionProps} from './TextCollection';
